export default "__VITE_ASSET__Cf_$R9et__"